var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('i',{staticClass:"fas fa-book"}),_c('div',{staticClass:"group-h1"},[_c('h1',[_vm._v(_vm._s(_vm.name))]),_c('p',[_vm._v("Coordonnées : "+_vm._s(_vm.lng)+"° Nord, "+_vm._s(_vm.lat)+"° Est")])])])}
var staticRenderFns = []

export { render, staticRenderFns }